<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" lg="6">
          <v-sheet class="neu-glow with-radius fill-height" height="100%">
            <v-img
              src="/static/ob-animated-isometric/404-error-animate.svg"
              lazy-src="/static/ob-animated-isometric/504-error-gateway-timeout-animate.svg"
              height="400"
              contain
            >
            </v-img>
            <v-row justify="end" class="fill-height">
              <v-col class="text-center px-10" cols="12">
                <h3 class="mb-1 mt-4">
                  {{$t(page+'.Sorry, too many users')}}
                </h3>                
              </v-col>
              
              <v-col class="text-center px-10" cols="12">
                <v-btn
                  color="info"
                  :href="origin"
                  class="mb-5"
                  >{{$t(page+'.Try again')}}!</v-btn
                >
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>

export default {
  created(){
    document.title = 'iBookrestaurant | error';
    this.origin='https://'+window.location.host;
    const host = window.location.host;
    const parts = host.split('.');
    console.log(46,host,parts);
    console.log(47,this.$route)
  },
  data() 
  {
    return {
      page:'Booking',
      origin:null
    }
  }
};
</script>